import React, { createContext, useContext, useState, useCallback } from "react";
import { api } from "../lib/api";

const AdminContext = createContext(null);
export const useAdmin = () => useContext(AdminContext);

export const AdminProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("admin_token"));

  const login = useCallback(async (password) => {
    const { data } = await api.post("/admin/login", { password });
    localStorage.setItem("admin_token", data.token);
    setToken(data.token);
    return true;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("admin_token");
    setToken(null);
  }, []);

  return (
    <AdminContext.Provider value={{ token, isAuthed: !!token, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
};
